import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  Injector,
  Input,
  ViewChild
} from '@angular/core';
import { CdkPortal, DomPortalOutlet } from '@angular/cdk/portal';

@Component({
  selector: 'app-page-title-portal',
  template: '<ng-template cdk-portal><ng-content></ng-content></ng-template>'
})
export class PageTitlePortalComponent implements AfterViewInit {
  @ViewChild(CdkPortal)
  private portal: CdkPortal;

  private host: DomPortalOutlet;

  @Input() public name: string = 'page';

  constructor(private cfr: ComponentFactoryResolver,
              private appRef: ApplicationRef,
              private injector: Injector) {
  }

  public ngAfterViewInit(): void {
    this.host = new DomPortalOutlet(
      document.querySelector(`#${ this.name }-title-portal`),
      this.cfr,
      this.appRef,
      this.injector
    );

    this.host.attach(this.portal);
  }

  public ngOnDestroy(): void {
    this.host.detach();
  }
}
